<template>
  <v-app id="inspire">
    <v-main class="main--landing">
      <v-row no-gutters class="flex">
        <v-col id="display1" cols="12" md="6" sm="6">
          <terms />
        </v-col>
        <v-col id="display2" cols="12" md="6" sm="6">
          <login />
        </v-col>
      </v-row>
    </v-main>
    <spinner />
    <OtpVerification />
    <!--    <FooterComponent opacity="0.65" />-->
  </v-app>
</template>

<script>
import { AuthService } from "../../auth";
// import FooterComponent from "../../../components/FooterComponent";
import Spinner from "../../../plugins/loader/views/Spinner";
import Login from "../../auth/components/Login.vue";
// import ActivationSearch from "../../activation/components/ActivationSearch.vue";
// import ActivationCode from "../../activation/components/ActivationCode.vue";
import Terms from "../components/Terms.vue";
// import InfoAlerts from "../../../plugins/info/InfoAlerts.vue";
import OtpVerification from "../../../plugins/verify/OtpVerification.vue";

export default {
  name: "LandingComponent",
  data: function () {
    return {
      message: [
        "To Activate:",
        "Option 1: Get your student details by searching using your student Number/ID Number/Reg No./FullName/Surname e.g. CCT0000123 which will populate the neccessary fields below. then enter any blank fields (if there are any).",
        "Option 2: Enter blank fields below the search field then <strong> click on the ACTIVATE button </strong>",
        "Steps after clicking the <strong>ACTIVATE</strong> button:",
        [
          "An <strong> OTP code </strong> will be sent (via sms) to the Phone number and Email Entered.",
          "Enter the code on the Activation Code Field.",
          "Enter your password then confirm the passwrod your entered. (Passwords must match)",
          "Finally click on the <strong>SUBMIT</strong> button to activate.",
        ],
      ],
    };
  },
  components: {
    /** FooterComponent,*/
    Spinner,
    Login,
    // ActivationSearch,
    // ActivationCode,
    Terms,
    // InfoAlerts,
    OtpVerification,
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Landing/getCompanyInfo");
      v.$store.dispatch("Application/getSetupProgrammes");
    });
  },

  computed: {
    company() {
      return this.$store.getters["Landing/company"];
    },

    auth() {
      return AuthService;
    },

    activationResults() {
      return this.$store.getters["Activation/activationGetter"](
        "activationResults",
      );
    },

    items() {
      return [
        {
          name: "APPLICATIONS",
          icon: "mdi-account-check",
          description: "New student applications",
        },
        {
          name: "EXAMINATION",
          icon: "mdi-file-check",
          description: "Book for exams, download timetable and result slips",
        },
      ];
    },
  },
};
</script>

<style>
@import url("../../auth/styles.css");
</style>
